__turbopack_context__.v({
  "actions": "filtersSection-module-scss-module__tOwTdG__actions",
  "breadcrumbs": "filtersSection-module-scss-module__tOwTdG__breadcrumbs",
  "description": "filtersSection-module-scss-module__tOwTdG__description",
  "filtersSection": "filtersSection-module-scss-module__tOwTdG__filtersSection",
  "fourColumn": "filtersSection-module-scss-module__tOwTdG__fourColumn",
  "headPart": "filtersSection-module-scss-module__tOwTdG__headPart",
  "notifications": "filtersSection-module-scss-module__tOwTdG__notifications",
  "product": "filtersSection-module-scss-module__tOwTdG__product",
  "productsList": "filtersSection-module-scss-module__tOwTdG__productsList",
  "title": "filtersSection-module-scss-module__tOwTdG__title",
  "twoColumn": "filtersSection-module-scss-module__tOwTdG__twoColumn",
});
